type DialogProps = { message: string; onClose: () => void }

export default function Dialog({ message, onClose }: DialogProps) {
    return (
        <div className="dialog-overlay" onClick={onClose}>
            <div className="dialog-box" onClick={e => e.stopPropagation()}>
                <p>{message}</p>
                <button className="valid-button" onClick={onClose}>OK</button>
            </div>
        </div>
    );
}
